import { ChangeDetectionStrategy, Component, Input, inject } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
    standalone: true,
    selector: 'app-json-ld',
    template: '',
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        '[innerHTML]': 'jsonLD',
    },
})
export class JsonLdComponent {
    @Input() public set json(currentValue: unknown) {
        this.jsonLD = this.getSafeHtml(currentValue);
    }
    protected jsonLD?: SafeHtml;

    private sanitizer = inject(DomSanitizer);

    private getSafeHtml(value: unknown): SafeHtml {
        const json = value ? JSON.stringify(value, null, 2).replace(/<\/script>/g, '<\\/script>') : '';
        const html = `<script type="application/ld+json">${json}</script>`;

        return this.sanitizer.bypassSecurityTrustHtml(html);
    }
}
